export const PLATFORM = {
  WEB: {
    LONG: 'web',
    SHORT: 'w',
  },
  ANDROID: {
    LONG: 'android',
    SHORT: 'aos',
  },
  IOS: 'ios',
}
